module.exports = __webpack_public_path__ + "img/haft-poznan-03.b9f38538.jpg";